import React, {useMemo} from 'react';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

type Props = {
    emailTypeCode: string,
    trackedEmailTypes: DictionaryItem[],
};

export const EmailTypeCell = ({emailTypeCode, trackedEmailTypes}: Props) => {
    const emailTypeDescription = useMemo(() => {
        const actionType = trackedEmailTypes.find(item => item.code === emailTypeCode);
        return actionType?.description || emailTypeCode;
    }, [emailTypeCode, trackedEmailTypes]);

    return (
        <EllipsisTextHint title={emailTypeDescription}>
            <strong>{emailTypeDescription}</strong>
        </EllipsisTextHint>
    );
};
